import { GenericModal } from "@finanedi.es/front/common/atoms"

import { LeyAntiFraudeForm } from "../ley-antifraude-form"
import { ILeyAntiFraudeFormModalProps } from "./interfaces"
import { TLeyAntifraudeFormModalTitle } from "./templates"

export const LeyAntiFraudeFormModal = ({
  nif,
  razonSocial,
  isOpen,
  handleCloseModal,
  estado,
  motivo,
}: ILeyAntiFraudeFormModalProps) => {
  return (
    <div className='fs-flex fs-justify-center fs-items-center fs-w-full'>
      <GenericModal
        open={isOpen}
        onClose={handleCloseModal}
        header={<TLeyAntifraudeFormModalTitle />}
        className='fs-w-full tablet:fs-w-2/4 laptop:fs-w-1/3 laptop:fs-min-w-[400px] 1k:fs-w-1/5 '
      >
        <LeyAntiFraudeForm
          onClose={handleCloseModal}
          nif={nif}
          razonSocial={razonSocial}
          estado={estado}
          motivo={motivo}
        />
      </GenericModal>
    </div>
  )
}
